<template>
  <div class="section-blog-list">
    <layout-loader v-show="loading"/>
    <div class="container">
      <div class="breadcrumb-sorted-block">
        <ui-breadcrumbs></ui-breadcrumbs>
      </div>
      <div class="header">
        <div class="great-title">
          <h1>{{ titlepage }}</h1>
        </div>
      </div>
      <div class="wrapper">
        <div class="middle-title">
          <h2>
            {{ this.$store.state.langs.TITLE_BLOG }}
          </h2>
        </div>
        <div class="subtitle">
          <span>
            {{ this.$store.state.langs.TITLE_BLOG_SUB_TITLE }}
          </span>
        </div>
        <div class="items">

          <a title=""
             v-for="(item, index) in posts"
             :key="index"
             :href="item.DETAIL_PAGE_URL">
            <layout-post-card>
              <img slot="pic" :src="item.PREVIEW_PICTURE" :alt="item.NAME">
              <span slot="title">
                {{ item.NAME }}
              </span>
              <span slot="desc" v-html="item.PREVIEW_TEXT"></span>
            </layout-post-card>
          </a>


        </div>


        <div class="moreListBlock" v-if="moreButton">
          <ui-button @click="moreShow()">
            {{ this.$store.state.langs.SHOW_MORE }}
          </ui-button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
    import layoutPostCard from '@/components/layout/layout-post-card'
    import uiBreadcrumbs from '@/components/ui/ui-breadcrumbs'
    export default {
        components: {
            layoutPostCard,
            uiBreadcrumbs
        },
        props: {
            titlepage: ""
        },
        data() {
            return {
                posts: [],
                loading: false,
                moreButton: false,
                page: 1,
                pagen: 1,
                pagecount: 0
            }
        },
        created () {
            this.postsRequest()
        },
        methods: {
            async postsRequest() {
                this.loading = true;
                const responsePosts  = (
                    await this.$axios({
                        url: '/ajax/blogs.php',
                        method: 'post',
                        data: {
                            clear_cache: this.getGet('clear_cache'),
                            SITE_ID: this.$store.state.langs.SITE_ID,
                            pagen: this.pagen,
                            pagecount: this.pagecount,
                            page: this.page
                        }
                    })
                )
                if (responsePosts) {
                  if(responsePosts.data.posts) {
                    this.posts = this.posts.concat.apply(this.posts, responsePosts.data.posts);
                    //this.pagen = parseInt(responsePosts.data.pagen);
                    this.pagecount = parseInt(responsePosts.data.pagecount);
                    if (this.page >= parseInt(responsePosts.data.pagecount)) {
                      this.moreButton = false
                    } else {
                      this.moreButton = true
                    }
                  }
                    this.loading = false;
                } else {
                    console.log('responsePosts')
                }
            },
            getGet(name) {
                var searchString = new URLSearchParams(window.location.search);
                var res = searchString.get(name);
                return res;
            },
            moreShow() {
                this.loading = true;
                this.page++;
                this.postsRequest()
            },
        },
        mounted(){
            document.querySelector('.doH1').remove();
        }
    }
</script>

<style lang="scss" scoped>
  .section-blog-list {
    padding-bottom: 5em;
  }
  .wrapper {
    background: var(--bg);
    padding: 4em;
  }
  .items {
    margin-top: 3.5em;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.875em;
  }
  .moreListBlock{
    text-align: center;
    padding-top: 40px;
  }
  @media screen and (max-width: 767px) {
    .wrapper {
      padding: 2em;
    }
    .items {
      display: block;
      & > * {
        display: block;
        margin-bottom: 3em;
      }
    }
  }
</style>